(function () {
  'use strict';

  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function shortest(d) {
    return ((((d + 180) % 360) + 360) % 360) - 180;
  }

  function Orbit(root) {
    this.root = root;
    this.stage = root.querySelector('.a3d__stage');
    this.ring = root.querySelector('.a3d__ring');
    this.items = Array.prototype.slice.call(root.querySelectorAll('.a3d__item'));
    this.n = this.items.length;
    if (!this.stage || !this.ring || this.n < 2) return;
    this.step = 360 / this.n;
    this.rot = 0;
    this.vel = 0;
    this.target = null;
    this.speed = parseFloat(root.getAttribute('data-speed')) || 0;
    this.dragging = false;
    this.hovering = false;
    this.focused = false;
    this.visible = false;
    this.running = false;
    this.raf = 0;
    this.moved = 0;
    this.resumeAt = 0;
    this.front = -1;
    this.last = 0;
    this.nameEl = root.querySelector('[data-a3d-name]');
    this.priceEl = root.querySelector('[data-a3d-price]');
    this.linkEl = root.querySelector('[data-a3d-link]');
    this.tickBound = this.tick.bind(this);
    this.bind();
    this.render();
    this.observe();
  }

  Orbit.prototype.reduced = function () {
    return reduceMq.matches;
  };

  Orbit.prototype.goTo = function (i) {
    var idx = ((i % this.n) + this.n) % this.n;
    this.target = -idx * this.step;
    this.resumeAt = performance.now() + 5000;
    this.start();
  };

  Orbit.prototype.snapNearest = function (extra) {
    var i = Math.round(-(this.rot + (extra || 0)) / this.step);
    this.goTo(i);
  };

  Orbit.prototype.bind = function () {
    var self = this;
    var stage = this.stage;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      self.dragging = true;
      self.moved = 0;
      self.lastX = e.clientX;
      self.lastT = performance.now();
      self.vel = 0;
      self.target = null;
      self.pointerId = e.pointerId;
    });

    stage.addEventListener('pointermove', function (e) {
      if (!self.dragging) return;
      var dx = e.clientX - self.lastX;
      var now = performance.now();
      self.moved += Math.abs(dx);
      if (self.moved > 6 && !self.captured) {
        self.captured = true;
        stage.classList.add('is-dragging');
        try {
          stage.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      if (self.captured) {
        var deg = dx * 0.3;
        self.rot += deg;
        self.vel = (deg / Math.max(1, now - self.lastT)) * 1000;
      }
      self.lastX = e.clientX;
      self.lastT = now;
    });

    function end(e) {
      if (!self.dragging) return;
      var wasDrag = self.captured;
      self.dragging = false;
      self.captured = false;
      stage.classList.remove('is-dragging');
      try {
        stage.releasePointerCapture(e.pointerId);
      } catch (err) {}
      if (wasDrag) {
        self.suppress = true;
        setTimeout(function () {
          self.suppress = false;
        }, 0);
        self.snapNearest(self.vel * 0.12);
        self.vel = 0;
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    this.root.addEventListener(
      'click',
      function (e) {
        if (self.suppress) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    stage.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') self.hovering = true;
    });
    stage.addEventListener('pointerleave', function () {
      self.hovering = false;
    });

    this.root.addEventListener('focusin', function (e) {
      var li = e.target.closest ? e.target.closest('.a3d__item') : null;
      self.focused = true;
      if (li) self.goTo(self.items.indexOf(li));
    });
    this.root.addEventListener('focusout', function () {
      self.focused = false;
    });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.goTo(self.front - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.goTo(self.front + 1);
      }
    });

    var prev = this.root.querySelector('[data-a3d-prev]');
    var next = this.root.querySelector('[data-a3d-next]');
    if (prev)
      prev.addEventListener('click', function () {
        self.goTo(self.front - 1);
      });
    if (next)
      next.addEventListener('click', function () {
        self.goTo(self.front + 1);
      });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop();
      else if (self.visible) self.start();
    });
  };

  Orbit.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.visible = true;
      this.start();
      return;
    }
    new IntersectionObserver(
      function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible) self.start();
        else self.stop();
      },
      { threshold: 0.05 }
    ).observe(this.root);
  };

  Orbit.prototype.start = function () {
    if (this.raf || (!this.visible && this.target === null)) return;
    this.running = true;
    this.last = performance.now();
    this.raf = requestAnimationFrame(this.tickBound);
  };

  Orbit.prototype.stop = function () {
    this.running = false;
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = 0;
  };

  Orbit.prototype.tick = function (now) {
    if (!this.running) {
      this.raf = 0;
      return;
    }
    var dt = Math.min(0.05, (now - this.last) / 1000);
    this.last = now;
    if (!this.dragging) {
      if (this.target !== null) {
        var diff = shortest(this.target - this.rot);
        if (this.reduced() || Math.abs(diff) < 0.05) {
          this.rot += diff;
          this.target = null;
        } else {
          this.rot += diff * Math.min(1, dt * 7);
        }
      } else if (!this.hovering && !this.focused && !this.reduced() && this.speed > 0 && now > this.resumeAt) {
        this.rot -= this.speed * dt;
      }
    }
    this.render();
    this.raf = requestAnimationFrame(this.tickBound);
  };

  Orbit.prototype.render = function () {
    var rot = this.rot;
    this.ring.style.setProperty('--rot', rot.toFixed(2) + 'deg');
    var best = 0;
    var bestD = -2;
    for (var i = 0; i < this.n; i++) {
      var d = Math.cos(((i * this.step + rot) * Math.PI) / 180);
      var el = this.items[i];
      el.style.setProperty('--d', d.toFixed(3));
      el.style.setProperty('--bb', (-(i * this.step + rot)).toFixed(2) + 'deg');
      var back = d < 0.35;
      if (back !== el._back) {
        el._back = back;
        el.classList.toggle('is-back', back);
      }
      if (d > bestD) {
        bestD = d;
        best = i;
      }
    }
    if (best !== this.front) {
      this.front = best;
      this.updateInfo();
    }
  };

  Orbit.prototype.updateInfo = function () {
    var el = this.items[this.front];
    if (!el) return;
    if (this.nameEl) this.nameEl.textContent = el.getAttribute('data-title') || '';
    if (this.priceEl) this.priceEl.textContent = el.getAttribute('data-price') || '';
    if (this.linkEl) this.linkEl.setAttribute('href', el.getAttribute('data-url') || '#');
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-a3d]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root._a3d) return;
      root._a3d = new Orbit(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
